import { render, staticRenderFns } from "./Canceled.vue?vue&type=template&id=af88acd0&"
import script from "./Canceled.vue?vue&type=script&lang=js&"
export * from "./Canceled.vue?vue&type=script&lang=js&"
import style0 from "./Canceled.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Canceled.vue"
export default component.exports